import {
    LiquiditySummaryConfiguration,
    initialLiquiditySummaryConfiguration,
} from './configuration/LiquiditySummaryConfiguration';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';

export type LiquiditySummaryWidgetState =
    WidgetWithConfigState<LiquiditySummaryConfiguration>;

export interface LiquiditySummaryWidgetsState {
    [widgetId: string]: LiquiditySummaryWidgetState;
}

export const initialLiquiditySummaryWidgetState: LiquiditySummaryWidgetState = {
    config: initialLiquiditySummaryConfiguration,
};

export const initialLiquiditySummaryWidgetsState: LiquiditySummaryWidgetsState =
    {};
